import 'gridstrap/svg-symbols/magnifying-glass.svg?sprite';
import './form-search.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSFormSearch } from './form-search';

components.register({
	selector: '.gs-FormSearch',
	controller: GSFormSearch
});
